import { FaBuilding, FaHandshake, FaUser } from 'react-icons/fa';
import ConnectingPeople from '../assets/img/home/conecta.png';
import Uniao from '../assets/img/home/uniao.png';
import Perfis from '../assets/img/home/perfis.png';
import Fluxo from '../assets/img/home/fluxo.png';
import Agilidade from '../assets/img/home/agilidade.png';
import { useTranslation } from 'react-i18next';

const NewHome = () => {
   const { t } = useTranslation('new-home');

   return (
      <>
         <section className="opportunity-talents-section">
            <div className="container">
               <div className="text">
                  <h1>{t('opportunity-talents.title')}</h1>
                  <p>{t('opportunity-talents.subtitle')}</p>
               </div>

               <div className="buttons-links">
                  <button className="call-to-action-btn">{t('opportunity-talents.buttons.candidate')} <br /> {t('opportunity-talents.buttons.candidate2')}</button>
                  <button className="call-to-action-btn">{t('opportunity-talents.buttons.company')} <br /> {t('opportunity-talents.buttons.company2')}</button>
                  <button className="call-to-action-btn">{t('opportunity-talents.buttons.company3')} <br /> {t('opportunity-talents.buttons.company4')}</button>
               </div>
            </div>
         </section>

         <section className="the-worky-connects">
            <div className="container">
               <div className="texts">
                  <h2>{t('the-worky.title')}</h2>
                  <p>{t('the-worky.description1')}</p>
                  <p>{t('the-worky.description2')}</p>
                  <p>{t('the-worky.description3')}</p>
               </div>
               <img src={ConnectingPeople} alt={t('the-worky.img-alt')}></img>
            </div>
         </section>

         <section className="paths-to-connect">
            <div className="container">
               <h2>{t('paths-to-connect.title')}</h2>
               <div className="cards-wrapper">

                  <div className="card">
                     <div>
                        <div className="avatar">
                           <FaUser />
                        </div>

                        <h3>{t('paths-to-connect.cards.candidate.title')}</h3>
                     </div>

                     <ul className="card-list">
                        <li>{t('paths-to-connect.cards.candidate.list1')}</li>
                        <li>{t('paths-to-connect.cards.candidate.list2')}</li>
                        <li>{t('paths-to-connect.cards.candidate.list3')}</li>
                     </ul>

                     <button className="call-to-action-btn">{t('paths-to-connect.cards.candidate.button')}</button>
                  </div>

                  <div className="card">
                     <div>
                        <div className="avatar">
                           <FaBuilding />
                        </div>

                        <h3>{t('paths-to-connect.cards.jobs.title')}</h3>
                     </div>

                     <ul className="card-list">
                        <li>{t('paths-to-connect.cards.jobs.list1')}</li>
                        <li>{t('paths-to-connect.cards.jobs.list2')}</li>
                        <li>{t('paths-to-connect.cards.jobs.list3')}</li>
                     </ul>

                     <button className="call-to-action-btn">Publicar Vaga</button>
                  </div>

                  <div className="card">
                     <div>
                        <div className="avatar">
                           <FaHandshake />
                        </div>

                        <h3>{t('paths-to-connect.cards.support.title')}</h3>
                     </div>

                     <ul className="card-list">
                        <li>{t('paths-to-connect.cards.support.list1')}</li>
                        <li>{t('paths-to-connect.cards.support.list2')}</li>
                        <li>{t('paths-to-connect.cards.support.list3')}</li>
                     </ul>

                     <button className="call-to-action-btn">{t('paths-to-connect.cards.support.button')}</button>
                  </div>

               </div>
            </div>

         </section>

         <section className="how-it-works">
            <div className="container">
               <h2>Como funciona?</h2>

               <p>Candidatos encontram vagas e se aplicam com um clique.</p>
               <p>Empresas escolhem se querem fazer por conta própria ou com a nossa ajuda.</p>
               <p>Nós cuidamos para que essa conexão seja leve, eficaz e humana.</p>
            </div>
         </section>

         <section className="what-moves-us">
            <div className="container">
               <h2>{t('what-moves-us.title')}</h2>
               <ul className="list">
                  <li className='list-item'>
                     <img width={128} src={Uniao} alt="" />
                     <p>{t('what-moves-us.items.first')}</p>
                  </li>
                  <li className='list-item'>
                     <img width={128} src={Perfis} alt="" />
                     <p>{t('what-moves-us.items.second')}</p>
                  </li>
                  <li className='list-item'>
                     <img width={128} src={Fluxo} alt="" />
                     <p>{t('what-moves-us.items.third')}</p>
                  </li>
                  <li className='list-item'>
                     <img width={180} src={Agilidade} alt="" />
                     <p>{t('what-moves-us.items.fourth')}</p>
                  </li>
               </ul>
            </div>
         </section>

         <section className="lets-go-together">
            <div className="container">
               <h2>{t('go-together.title')}</h2>

               <p>{t('go-together.description')}</p>

               <div className="buttons">
                  <button className="call-to-action-btn">{t('go-together.buttons.first')}</button>
                  <button className="call-to-action-btn">{t('go-together.buttons.second')}</button>
                  <button className="call-to-action-btn">{t('go-together.buttons.third')}</button>
               </div>
            </div>
         </section>
      </>
   )
}

export default NewHome